import { ImageCell } from '@/components/shared/ImageCell';
import type { TourType } from '@/config/objects/tour-types';

interface TourTypeImageCellProps {
  tourType?: TourType;
  size?: 'sm' | 'lg';
}

/**
 * Editable tour type image cell component with upload and delete actions
 */
export function TourTypeImageCell({ tourType, size = 'sm' }: TourTypeImageCellProps) {
  return (
    <ImageCell
      item={tourType}
      endpoint="/tour-types"
      entityName="Tour Type"
      imageLabel="Tour Type Image"
      getFeaturedImage={(item) => item.featuredImage}
      getItemId={(item) => item.id}
      size={size}
    />
  );
}
